module.exports = __webpack_public_path__ + "static/media/galerija_2017 (24).143d18e5.jpg";